import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import I18nProvider from "./context/I18nProvider";
import LocalizationProvider from "./context/LanguageProvider";
import { restoreSession } from "./lib/session";
import router from "./routes";

export default function App() {
  // The token is not kept across reloads: routes render once the cookie restore has answered,
  // so a signed-in admin is not bounced to /login first.
  const [sessionReady, setSessionReady] = useState(false);
  useEffect(() => {
    void restoreSession().finally(() => setSessionReady(true));
  }, []);

  if (!sessionReady) {
    return (
      <Box
        sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <I18nProvider>
      <LocalizationProvider>
        <RouterProvider router={router} />
        <ToastContainer style={{ zIndex: 10000 }} />
      </LocalizationProvider>
    </I18nProvider>
  );
}
